<mat-toolbar class="content-header">
  <h1 class="page-title">
    <mat-icon class="header-icon" fontIcon="checklist"></mat-icon>
    {{ 'actions.title' | translate }}
  </h1>

  <span class="toolbar-spacer"></span>

  <lib-button icon="add" (click)="add()" color="primary" tooltip="{{ 'actions.add' | translate }}">
  </lib-button>
  <lib-button icon="download" color="secondary" [text]="'actions.export' | translate" [disabled]="!actions.length"
    (click)="exportCSV()">
  </lib-button>
</mat-toolbar>

<ng-container>
  <div class="option-menu">
    <div class="filters">

      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>{{ 'actions.status_label' | translate }}</mat-label>
        <mat-select [(ngModel)]="filterStatus" (selectionChange)="applyFilters()">
          <mat-option value="">{{ 'form.all' | translate }}</mat-option>
          <mat-option *ngFor="let s of statusOptions" [value]="s">
            {{ 'actions.status.' + s | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>{{ 'actions.type_label' | translate }}</mat-label>
        <mat-select [(ngModel)]="filterType" (selectionChange)="applyFilters()">
          <mat-option value="">{{ 'form.all' | translate }}</mat-option>
          <mat-option *ngFor="let t of typeOptions" [value]="t">
            {{ 'actions.type.' + t | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>{{ 'actions.priority_label' | translate }}</mat-label>
        <mat-select [(ngModel)]="filterPriority" (selectionChange)="applyFilters()">
          <mat-option value="">{{ 'form.all' | translate }}</mat-option>
          <mat-option *ngFor="let p of priorityOptions" [value]="p">
            {{ 'actions.priority.' + p | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <app-search-bar (searchText)="search($event)"></app-search-bar>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="actionsData" matSort>
      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon fontIcon="task_alt"></mat-icon>
            {{ 'actions.field.title' | translate }}
          </div>
        </th>
        <td mat-cell *matCellDef="let row" class="clickable" (click)="edit(row)">
          {{ row.title }}
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon fontIcon="category"></mat-icon>
            {{ 'actions.field.type' | translate }}
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          {{ 'actions.type.' + row.type | translate }}
        </td>
      </ng-container>

      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon fontIcon="priority_high"></mat-icon>
            {{ 'actions.field.priority' | translate }}
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="chip chip-{{ priorityChipColor(row.priority) }}">
            {{ 'actions.priority.' + row.priority | translate }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon fontIcon="flag"></mat-icon>
            {{ 'actions.field.status' | translate }}
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <span class="chip chip-{{ statusChipColor(row.status) }}">
            {{ 'actions.status.' + row.status | translate }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon fontIcon="person"></mat-icon>
            {{ 'actions.field.assignee' | translate }}
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          {{ assigneeLabel(row) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          <div class="header-content">
            <mat-icon fontIcon="event"></mat-icon>
            {{ 'actions.field.dueDate' | translate }}
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          {{ row.dueDate ? (row.dueDate | timeFormat: 'dd/MM/yyyy') : '—' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="risk">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            <mat-icon fontIcon="gpp_maybe"></mat-icon>
            {{ 'actions.field.risk' | translate }}
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngIf="row.risks?.length; else noRisk">
            <div class="risk-chips">
              <a *ngFor="let c of row.risks" class="risk-chip" [routerLink]="['/project/risk', c.id]">
                <lib-chip color="danger" icon="gpp_maybe"
                  [text]="c.payload?.displayTitle || c.payload?.title || c.id"></lib-chip>
              </a>
            </div>
            <ng-template #noRisk><span>—</span></ng-template>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <div class="header-content">
            <mat-icon fontIcon="edit"></mat-icon>
            Actions
          </div>
        </th>
        <td mat-cell *matCellDef="let row">
          <lib-button icon="edit" color="none" textColor="secondary" tooltip="{{ 'actions.edit' | translate }}"
            (click)="edit(row)">
          </lib-button>
          <lib-button icon="delete" color="none" textColor="danger" tooltip="{{ 'actions.delete' | translate }}"
            (click)="remove(row)">
          </lib-button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="actionsColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: actionsColumns;"></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="actionsColumns.length">
          <lib-no-data message="actions.empty" description="actions.empty_desc" icon="checklist">
          </lib-no-data>
        </td>
      </tr>
    </table>

    <mat-paginator #actionPaginator [length]="actionsCount" [pageSize]="10" [pageSizeOptions]="[10, 25, 100]"
      class="paginator">
    </mat-paginator>

    <div *ngIf="loading" class="table-overlay">
      <app-spinner></app-spinner>
    </div>
  </div>
</ng-container>